const DecryptageUtils = {
  encodeCategory(category) {
    if (!category) {
      return '';
    }

    return category.replace('/', '-');
  },
  encodeSubCategory(subCategoriesNames) {
    let cat = subCategoriesNames;

    if (!cat) {
      return '';
    }

    if (Array.isArray(cat)) {
      cat = cat.join(',');
    }

    return DecryptageUtils.encodeCategory(cat);
  },
};

export default DecryptageUtils;
